// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__-IQJ5","select":"Header_select__2Vk53","clinic":"Header_clinic__1dApi"};